import { render, staticRenderFns } from "./DeleteGroup.vue?vue&type=template&id=e1a2c6cc&scoped=true"
import script from "./DeleteGroup.vue?vue&type=script&lang=js"
export * from "./DeleteGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a2c6cc",
  null
  
)

export default component.exports